import { ConfirmationModal } from './myConfirmModal';

require('./myConfirmModal.scss');

export const myConfirmModal = {
  template: require('./myConfirmModal.html'),
  controllerAs: 'ctrl',
  controller: ConfirmationModal,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
};
